import React from "react"
import { Box, IconButton, Button, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { RefreshCircle, MoreCircle, Trash } from 'iconsax-react';
import styles from '../my-data.module.scss';
import Primary from '../../icons/primary.png';

const LanguageItem = ({ language, setLanguage, lang, makePrimary, switchLang, deleteLang, noActions ,forceStopOption, closeDropdown}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePrimary = (lang) => {
        makePrimary(lang);
        handleClose();
    }

    const handleSwitchLang = (lang) => {
        switchLang(lang);
        handleClose();
    }

    const handleDeleteLang = (lang) => {
        deleteLang(lang.language);
        handleClose();
    }

    return (
        <Box key={lang._id}>

            <Button
                key={lang.language}
                sx={{ width: '270px', margin: '10px', justifyContent: 'space-between' }}
                onClick={event => {
                    setLanguage(noActions ? lang.language : lang);
                    if (typeof closeDropdown !== "undefined") {
                        closeDropdown(false);
                    }
                }}
                variant={language?.language === lang.language ? 'contained' : ''}
                color={language?.language === lang.language ? 'secondary' : ''}
            >
                {lang.language}
                {lang.primary &&
                    <img src={Primary} alt="primary language" className={styles.primaryIcon} style={{ marginLeft: '10px' }} />
                }
            </Button>

            {!forceStopOption && !noActions &&
                <Tooltip title="Options">
                    <IconButton
                        id="basic-button"
                        aria-controls={open ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                        onClick={handleClick}
                        sx={{ mt: -1 }}
                    >
                        <MoreCircle
                            size="24"
                            variant="Bulk"
                        />
                    </IconButton>
                </Tooltip>
            }

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        borderRadius: "8px",
                        width: '170px',
                        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                        paddingTop: 0
                    },
                }}
            >
                {!lang.primary &&
                    <MenuItem onClick={() => handlePrimary(lang.language)}>
                        <ListItemIcon>
                            <img src={Primary} alt="primary language" className={styles.primaryIcon} />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ fontSize: '12px' }}>Make Primary</ListItemText>
                    </MenuItem>
                }
                <MenuItem onClick={() => handleSwitchLang(lang)}>
                    <ListItemIcon>
                        <RefreshCircle
                            size="20"
                            variant="Bulk"
                        />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: '12px' }}>Switch Language</ListItemText>
                </MenuItem>
                {!lang.primary &&
                    <MenuItem onClick={() => handleDeleteLang(lang)}>
                        <ListItemIcon>
                            <Trash
                                size="20"
                                variant="Bulk"
                            />
                        </ListItemIcon>
                        <ListItemText primaryTypographyProps={{ fontSize: '12px' }}>Delete</ListItemText>
                    </MenuItem>
                }
            </Menu>
        </Box>
    );
}

export default LanguageItem;